export default {
	"pages": {
		"root": {
			"name": "root",
			"children": [
				"6617165c6bbd200023699cb4",
				"6617165c6bbd200023699cb8",
				"6617165c6bbd200023699cbc",
				"661748b88d4a0c00202e398d"
			],
			"id": "root",
			"pageUrl": "root"
		},
		"6617165c6bbd200023699cb4": {
			"id": "6617165c6bbd200023699cb4",
			"name": "404",
			"pageUrl": "404"
		},
		"6617165c6bbd200023699cb8": {
			"id": "6617165c6bbd200023699cb8",
			"name": "index",
			"pageUrl": "index",
			"seo": {
				"og:description": "It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference.",
				"title": "Home | Website Example",
				"og:title": "Home | Website Example",
				"og:image": "https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/website-example-quarkly.png?v=2020-11-05T19:48:01.806Z",
				"description": "It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference."
			}
		},
		"6617165c6bbd200023699cbc": {
			"id": "6617165c6bbd200023699cbc",
			"pageUrl": "about",
			"name": "About",
			"seo": {
				"og:title": "About | Website Example",
				"og:description": "It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference.",
				"description": "It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference.",
				"og:image": "https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/website-example-quarkly.png?v=2020-11-05T19:48:01.806Z",
				"title": "About | Website Example"
			}
		},
		"661748b88d4a0c00202e398d": {
			"pageUrl": "SignUp",
			"seo": {
				"og:image": "https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/website-example-quarkly.png?v=2020-11-05T19:48:01.806Z",
				"title": "Contact | Website Example",
				"og:title": "Contact | Website Example",
				"description": "It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference.",
				"og:description": "It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference."
			},
			"id": "661748b88d4a0c00202e398d",
			"name": "SignUp"
		}
	},
	"mode": "production",
	"projectType": "create-react-app",
	"site": {
		"styles": {},
		"seo": {}
	}
}